import { Suspense, useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import { Outlet } from 'react-router-dom';
import './Layout.scss';

const Layout = ({ selectedLoanTypeID }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerOpen = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);

  return (
    <>
      <Box>
        <Box className='layout-wrapper'>
          <Sidebar open={drawerOpen} onClose={handleDrawerClose} />
          <Box className='main-content' flexGrow={1}>
            <Header onMenuClick={handleDrawerOpen} />
            <Box className='content'>
              <Suspense
                fallback={
                  <Skeleton
                    variant='rectangular'
                    height={'100%'}
                    sx={{ margin: '16px', borderRadius: '16px' }}
                  />
                }
              >
                <Outlet key={selectedLoanTypeID} />
              </Suspense>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
